module.exports = {
  buttons: {
    backLink: "戻る",
    cancelButton: "キャンセル",
    chatWithAgentButton: "担当者にチャットで相談",
    closeButton: "閉じる",
    contactSupportButton: '<a href="" class="adsktm-show-contact-support-btn">サポートに相談</a>',
    copiedButton: "コピー完了",
    copyButton: "コピー",
    getStartedButton: "開始",
    haveAQuestion: "お問い合わせ",
    helpPanel: '<a target="_blank" href="https://knowledge.autodesk.com/ja/contact-support/installation-activation/activation-registration">お問い合わせ</a>',
    nextButton: "次へ",
    requiredLabel: "必須項目",
    restartButton: "再開",
    signInButton: "サインイン",
    submitAgainButton: "再送信",
    submitButton: "送信",
    tryAgainButton: "再試行",
    notNow: "後で",
    validate: "検証"
  },
  signIn: {
    gatheringInfo: "アカウント情報を収集中",
    helloUser: "<first-name>さん、こんにちは",
    justAMoment: "少しお待ちください...",
    signInNow: "<a>今すぐサインイン</a>",
    signInHelp: `<a target="_blank" href="https://knowledge.autodesk.com/ja/contact-support/account-management/account-creation-sign-profile-management">サインインできない場合はこちら</a>`,
    startAccessAccount: "まず、アカウントへアクセスすることから始めましょう。"
  },
  contactOptions: {
    addtlComments: "追加コメント(任意)",
    addtlCommentsMsg: "上記の詳細でお客様のケースをオープンします。他に伝えておきたいことがある場合は、こちらのスペースをお使いください。",
    addtlCommentsReqd: "説明",
    agentAvailable: "担当者が待機中",
    agentAvailableStdby: "担当者が待機中 - スタンバイ",
    agentUnavailable: "担当者が不在",
    cancelCase: "ケースをキャンセル",
    cancelChat: "チャットをキャンセル",
    caseConfirm1: "まもなく確認の電子メールをお送りいたします。電子メールが届かない場合は、迷惑メール フォルダやスパム メール フォルダを確認してください。",
    caseConfirm2: "担当者がケースを確認し、2 営業日以内に返信いたします。",
    caseDetails: "ケースの詳細",
    caseNumber: "ケース番号: <case-number>",
    caseSubmitted: "ケースは提出されました",
    chatWithAgent: "担当者にチャットで相談",
    closingWindowMsg: "つながる前にこのウィンドウを閉じると、チャットがキャンセルされることがあります。",
    connectMomentarily: "担当者におつなぎしています。",
    createCase: "ケースを作成",
    errorLabel: "エラー",
    forceStartChat: "<a>こちらをクリックするとチャットを開始できます。</a>",
    getCaseAnswer2Days: "2 日以内に回答いたします",
    mayCloseWindow: "このウィンドウを閉じることができます。",
    note: "注:",
    orSubmitCase: "もしくは、<a>ケースを提出<a/>してください。担当者が 2 営業日以内に返信いたします。",
    popUpBlocker: "ポップアップ ブロッカーを使用している場合は、",
    productLabel: "製品",
    sorryNoAgent: "申し訳ありません、ただいま担当者が不在にしております。",
    willUpdateAgent: "担当者が待機中になりましたら、こちらの画面が更新されます。",
    yourContactInfo: "連絡先情報"
  },
  welcome: {
    important: "重要:",
    noteForTheUser: "注:"
  },
  captchaScreen: {
    correctMsg: "一致しました",
    incorrectMsg: "一致しません。もう一度入力してください。",
    pageTitle: "セキュリティ チェック",
    typeCaptchaLabel: "上の画像の文字を入力してください"
  },
  contactInfoScreen: {
    emailDisclaimer: "これは、確認用のメールを送信するために必要です。",
    emailTitle: "電子メール",
    firstNamePlaceholder: "名",
    lastNamePlaceholder: "姓",
    nameLabel: "名前",
    pageTitle: "1. 連絡先情報"
  },
  reviewAccountInfo: {
    differentAccount: "<a>別のアカウントにサインイン</a>",
    emailConfirm: "アカウント情報の抽出と確認メールの送信にはこの電子メール アドレスが使用されます。",
    helloUser: "<first-name>さん、こんにちは!",
    pageTitle: "1. アカウント情報の確認",
    signedInAs: "次としてサインインしています:"
  },
  processInfoScreen: {
    checkSerialMsg: "このシリアル番号を確認するには、[Enter]を押します。",
    continueTyping: "次の形式でシリアル番号の入力を継続してください: XXX-XXXXXXXX",
    doNotNeedHula: "お客様のライセンス状況を確認いたしました。ホームユース ライセンスを改めてリクエストする必要はありません。同じシリアル番号を使用してこのソフトウェアをご自宅のコンピューターにインストールし、アクティベーションを行うことができます。",
    downloadYourProduct: `製品をダウンロードしてインストールしてください。追加のアクティベーションは必要ありません。`,
    emailForSerialNumPlaceholder: "関連付けられている電子メール",
    emailForSerialNumTitle: "シリアル番号に関連付けられている電子メール",
    emailForSerialNumTooltip: "これは、ソフトウェア コーディネータ、契約マネージャ、またはソフトウェアを購入した人の電子メール アドレスです",
    ineligiblePerpetual: 'このシリアル番号は永久ライセンス用です。ホームユース特典は<b>利用できません</b>。<br/><br/>オートデスク サブスクリプションならいつでも、どこにいてもソフトウェアが使用できます。サブスクリプションの特典についての詳細は、<a target="_blank" href="https://www.autodesk.co.jp/subscription">こちら</a>をご覧ください。',
    justTypeIn: "- シリアル番号が表示されない場合は入力してください。-",
    msgEducationSerialNum: "これは教育版ソフトウェアのシリアル番号です。",
    msgGoToEducationComm: '<a target="_blank" href="https://www.autodesk.co.jp/education/free-software/all">Education Community にアクセスしてください</a>',
    msgIndustryCollectionSerialNum: "このシリアル番号はコレクションの一部です: <collection-name>",
    msgNetworkSerialNum: `このシリアル番号は<Strong>ネットワーク ライセンス</Strong>用のため、アクティベーション コードは不要です。ネットワーク管理者に連絡して、ライセンスが正しく設定されていることを確認してください。`,
    msgSubscriptionSoftware: `このシリアル番号は<Strong>サブスクリプション製品</Strong>用のため、アクティベーション コードは不要です。インターネットに接続しているときに製品を起動してください。起動したら、<a target="_blank" href="https://www.autodesk.com/sign-in-activation-jpn">サインイン</a>するか<a target="_blank" href="https://www.autodesk.com/access-with-serial-number-jpn">シリアル番号</a>を入力します。`,
    msgBiCIndirectSoftware: "お客様のライセンスは改善されたアカウント体験の一部となったため、アクティベーション コードはもう必要ありません。Autodesk Account の電子メール アドレスとパスワードを使用してサインインするだけで、ソフトウェアの使用を開始できます(インターネットに接続されている必要があります)。",
    msgBicIndirectSCRole: '「お客様のライセンスには、ソフトウェア コーディネータの役割は含まれていません。詳細については、「<a target="_blank" href="https://knowledge.autodesk.com/ja/customer-service/account-management/users-software/classic-user-management/hybrid-admin-roles">」を参照してください。」</a>」を参照してください。」',
    msgBicIndirectCMRole: '契約管理者を変更してもプライマリ管理者には影響しません。この役割は Autodesk Account で割り当てることができます(「<a target="_blank" href="https://knowledge.autodesk.com/ja/customer-service/account-management/users-software/user-management/primary-admins">プライマリ管理者</a>」を参照)。',
    msgSN2010orOlder: `入力したシリアル番号は、古いバージョン用のものであるため、サポートされなくなりました。「 <a target="_blank" href="https://knowledge.autodesk.com/ja/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">資格要件</a>」を参照してください。`,
    myProductNotListed: "上記以外の製品",
    noResultsMsg: "検索結果はありません。 次の形式でシリアル番号を入力してください: XXX-XXXXXXXX",
    pageTitle: "2. 製品情報",
    partOfCollection: "この製品は、次のコレクションの一部です: <collection-name>",
    requestCodeTitle: "リクエスト コード",
    requestCodetooltip: '<a target="_blank" href="https://www.autodesk.com/find-request-code-jpn">リクエスト コー</a>ドの確認方法',
    selectPlaceholder: "選択",
    selectProduct: "特定の製品を選択",
    selectProductPlaceholder: "製品を選択",
    selectYourProductTitle: "製品を選択",
    serialNumberLabel: "シリアル番号",
    serialNumberPlaceholder: "名前で検索 - または - 番号を入力",
    serialNumbersInAccount: "お客様のアカウントのシリアル番号",
    serialNumberTooltip: '<a target="_blank" href="https://www.autodesk.com/find-serial-number-jpn">シリアル番号</a>の確認方法',
    yesOption: `はい`,
    noOption: `いいえ`,
    currentInfoTitle: "現在の情報",
    contractNumDisclaimer: `契約番号にハイフン(-)が含まれる場合はハイフンも含めてください。`,
    contractNumLabel: "契約番号",
    contractNumTooltip: '<a target="_blank" href="https://manage.autodesk.com">Autodesk Account</a> の[請求と注文]タブで契約番号を確認してください。'
  },
  authorizationRequestScreen: {
    enterEmail: "電子メール アドレスを入力",
    option1: "私はこの製品の管理者、契約管理者、またはソフトウェア コーディネーターです。",
    option2: "私は管理者、契約管理者、またはソフトウェア コーディネーターの代理でこのリクエストを行いました。担当者の電子メール アドレスは次のとおりです:",
    pageTitle: "3. このリクエストの認証",
    selectOne: "1 つ選択してください"
  },
  processingScreen: {
    firstMsg: "リクエストを処理中",
    takingLongerExpected: "申し訳ございませんが、予想よりも長く時間がかかっています。",
    updatedMsgLonger: "現在処理中です",
    willTakeSecs: "これは数秒かかる場合があります..."
  },
  successScreen: {
    expirationLine: "<br/>有効期限: <expiration-date>",
    infoWillBeEmailed: "この情報は、次の電子メール アドレスにも送信されます: <email>",
    pageTitle: "成功",
    prodSeatMulti: "<product-name> (ライセンス数: <number-seats>)<br/>",
    prodSeatSingle: "<product-name> (ライセンス数: 1)<br/>",
    pvApprovedMsg: "前バージョンのリクエストが承認されました。",
    pvInstruction: "次の情報を使用して、ソフトウェアのインストールとアクティベーションを行ってください。",
    reponseText: "取得したアクティベーション コード: <activation-code>",
    responseText1: "ホームユース ライセンスのリクエストが承認されました。",
    responseText2: "次の情報を使用して、ソフトウェアのインストールとアクティベーションを行ってください。インストール中に、「スタンドアロン」を選択してください。",
    responseText3: "シリアル番号: <serial-number><br/>プロダクト キー: <product-key>",
    updateDisclaimer: `変更内容がアカウントに表示されるまで、数時間かかりますのでご了承ください。`
  },
  errors: {
    emailNotAssocWithSerialNumber: "この電子メール アドレスはこのシリアル番号に関連付けられていません。",
    enterCMSCEmail: "この製品の契約管理者またはソフトウェア コーディネーターの電子メール アドレスを入力してください",
    enterComments: "説明を入力してください",
    enterEmail: "電子メール アドレスを入力してください",
    enterEmailAssociated: "関連付けられている電子メールを入力してください",
    enterFirstName: "名を入力してください",
    enterLastName: "姓を入力してください",
    enterRequestCode: "リクエスト コードを入力してください",
    enterSerialNumber: "シリアル番号を入力してください",
    enterValidFormat: "有効な形式で入力してください",
    invalidAutodeskSerialNumber: '<p>これは、オートデスクの有効なシリアル番号ではありません。</p><p>認定された購入元から購入したソフトウェアを使用していることを確認してください:</p><ul><li><a target="_blank" href="http://www.autodesk.com/store">Autodesk Store</a></li><li><a target="_blank" href="https://www.autodesk.co.jp/resellers/locate-a-reseller">認定リセラー</a></li><li><a target="_blank" href="https://www.autodesk.com/education/prepare-and-excel/authorized-academic-partner">教育パートナー</a></li></ul>',
    invalidLicenseModel: "この製品には無効なライセンス モデルがあります。",
    invalidRequestcode: "無効なリクエスト コード",
    invalidSerialNumber: "無効なシリアル番号",
    notCMSC: "弊社の記録では、あなたがこの製品の契約管理者またはソフトウェア コーディネーターであることを確認できませんでした。",
    oops: '申し訳ありません。要求の処理中に問題が発生しました。<a target="_blank" href="https://knowledge.autodesk.com/ja/contact-support/installation-activation/activation-registration">サポートに相談</a>',
    overActivation: "制限数を超えたアクティベーション",
    productExpired: "アクティベートしようとしている製品の有効期限が切れています。",
    reasonForActivation: "アクティベーションの理由",
    serialNumNotAssocWithSingleLicense: "このシリアル番号は、シングルユーザー ライセンスに関連付けられていません。",
    serialNumNotFound: "シリアル番号が見つかりません",
    serialNumNotRegisteered: 'このシリアル番号はまだ登録されていません。最初に<a target="_blank" href="http://registeronce.autodesk.com/">登録</a>してください。'
  },
  requestFailedScreen: {
    caseError: "申し訳ありません。ケースの送信中に問題が発生しました。",
    contactOptionsBelow: `サポートが必要な場合は、画面下のオプションを使用して<a id="go-to-contact-us" href="javascript:void(0);">お問い合わせ</a>ください。`,
    expiredSubsTitle: `期限切れのサブスクリプション`,
    expiredSubscription: `サブスクリプションが期限切れのため、このリクエストを完了できません。アカウント管理者に問い合わせるか、お客様の<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">アカウント</a>で契約更新オプションをご確認ください。`,
    inactiveSubsTitle: "サブスクリプションが有効ではありません",
    noActiveSubs: `サブスクリプションが有効になっていないか期限切れのため、このリクエストを完了できません。アカウント管理者に問い合わせるか、お客様の<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">アカウント</a>で契約更新オプションをご確認ください。`,
    pageTitle2: "要求を完了できません",
    pageTitle: "要求が失敗しました",
    prodNotEligibleTitle: "対象製品ではありません",
    prodNotRegisteredTitle: `未登録の製品`,
    prodNotRegistered: `製品が未登録のため、このリクエストを完了できません。<br><br><a target="_blank" href="https://registeronce.autodesk.com">製品の登録</a>`,
    responseText: "申し訳ありません。要求の処理中に問題が発生しました。"
  },
  gac: {
    welcome: {
      clickGetStarted: "アクティベーション コードを取得するには、[開始]をクリックしてください。",
      modalTitle: "アクティベーション コードを取得",
      noteBullet1: `アクティベーション コードが必要になるのは、永久ライセンスまたは教育機関限定ライセンス(学生または教員)のスタンドアロン製品を所有しており、さらに<strong>インターネットに接続できない</strong>場合のみです。`,
      noteBullet2: `<strong>インターネットに接続できる場合は、アクティベーション コードは不要です。</strong>製品を起動し、<a target="_blank" href="https://www.autodesk.com/sign-in-activation-jpn">サインイン</a>または<a target="_blank" href="https://www.autodesk.com/access-with-serial-number-jpn">シリアル番号の入力</a>の手順に従ってください。`
    },
    signInOptional: {
      title: "サインイン(任意)",
      message: `サインインすることで手続きが簡略化されますが、必須ではありません。`
    },
    overActScreen: {
      actAgainLabel: "再アクティベーションの理由を選択してください",
      pageTitle: "3. オーバーアクティベーションの理由",
      reason1: "新しいコンピュータ",
      reason2: "コンピュータの盗難",
      reason3: "ソフトウェアの再インストール",
      reason4: "その他",
      responseText: "このシリアル番号は以前アクティベートされています。",
      selectReason: "理由を選択"
    },
    requestFailedScreen: {
      gacExportControlBlock: '「お客様のオートデスク製品の使用資格は、現在標準の輸出審査を受けており、通常は数分かかります。後でもう一度試してください。 詳細については、オートデスクの「<a target="_blank" href="https://www.autodesk.com/company/legal-notices-trademarks/compliance">輸出コンプライアンス ポリシー</a>」を参照してください。」',
      gacProductKeyAndSerialNotFound: '一致する製品が見つかりませんでした。正しいシリアル番号が入力されていることを確認してください。詳細については、「<a target="_blank" href="https://knowledge.autodesk.com/ja/customer-service/download-install/activate/find-serial-number-product-key">シリアル番号とプロダクトキーを検索する</a>」を参照してください。',
      gacAssetNotFound: '正しいシリアル番号が入力されていることを確認してください。最近購入した製品の場合は、処理時間が長くなることがあります。詳細については、「<a target="_blank" href="https://knowledge.autodesk.com/ja/customer-service/download-install/download/subscription-downloads#missing">製品が表示されない場合</a>」を参照してください。',
      gacContactNotFound: "電子メールが見つかりません。このシリアル番号に対して正しい電子メール アドレスが入力されていることを確認してください。",
      gacGetAssetActivationCode: "問題が発生しました。<b>[再送信]</b>をクリックしてください。しばらく経っても問題が解決しない場合は、サポートにお問い合わせください。",
      gacFlexShortRequestCodeInvalid: "これは有効なリクエスト コードではありません。正しいコードが入力されていることを確認してください。"
    }
  },
  hula: {
    welcome: {
      clickGetStarted: "[開始]をクリックして、ホームユース特典用のシリアル番号を取得してください。",
      intro: "ホームユース ライセンスを取得するには、次の簡単な手順に従って操作してください。",
      modalTitle: "ホームユース ライセンスをリクエストする",
      noteBullet1: 'ホームユース特典は、<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-jpn">対象製品</a>のマルチユーザー アクセスのサブスクリプション、および保守プランを追加しているネットワーク ライセンスでご利用になれます。',
      noteBullet2: "シングルユーザーのサブスクリプションには、ホームユース特典が自動的に含まれています。同じシリアル番号を使用してこのソフトウェアをご自宅のコンピューターにインストールし、アクティベーションを行うことができます。"
    },
    processInfoScreen: {
      hulaEligibleVersionMsg: '対象のバージョンのみが表示されます。<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-jpn">資格要件を確認する</a>',
      crossGradeHulaMessage: `お客様のリクエストはこちらのサービスでは処理できません。選択したバージョンのホームユース ライセンスを取得するには、<a id="go-to-create-case" href="javascript:void(0);">ケースを作成</a>してください。2 営業日以内に折り返しご連絡を差し上げます。`
    },
    errors: {
      tokenFlexSerialNumber: `TokenFlex のシリアル番号が入力されました。ホームユースのライセンスを申請するには、Autodesk Premier Expert (<strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>) 宛に電子メールをお送りください。`
    },
    requestFailedScreen: {
      hulaEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-jpn">資格要件を確認する</a>',
      hulaIneligible: `お使いの製品はホームユース ライセンスの対象製品ではないため、このリクエストを完了できません。`,
      exportControlBlockOREmbergoList: `お客様のオートデスク製品の利用資格は現在、標準的な輸出審査を受けており、通常は数分かかります。詳細については、オートデスクの「<a href="https://www.autodesk.com/company/legal-notices-trademarks/compliance">輸出コンプライアンス ポリシー</a>」を参照してください。`
    }
  },
  pv: {
    welcome: {
      clickGetStarted: "[開始]をクリックして、ソフトウェアの前バージョンのアクセス権を取得してください。",
      intro: "次の手順に従って操作するだけで、簡単にソフトウェアの前バージョンを入手できます。",
      modalTitle: "前バージョンをリクエスト",
      noteBullet1: 'サブスクリプションをご契約中のお客様は、ご自身の<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">アカウント</a>にログインし、必要な前バージョンをダウンロードしてください。',
      noteBullet2: 'スタンドアロン ライセンスに保守プランを追加しているお客様は、こちらの方法を使用して<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-jpn">対象製品</a>の前バージョンをリクエストしてください。'
    },
    processInfoScreen: {
      noPvAvailable: 'リクエストした製品の前バージョンはご利用いただけなくなりました。詳細については、「<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-jpn">前バージョンに関するポリシー</a>」をご確認ください。',
      pvEduUserMsg: 'お客様は教育機関限定版ライセンスをご利用中です。<a target="_blank" href="https://www.autodesk.com/education/free-software/all">Education Community</a> にアクセスしてください。そちらで、3 バージョン前までのバージョンをダウンロードできます。',
      pvEligibleVersionMsg: '対象のバージョンのみが表示されます。<a target="_blank" href="https://knowledge.autodesk.com/ja/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">資格要件を確認する</a>',
      pvMultiUserSubsMsg: `お客様はマルチユーザー アクセスのサブスクリプションをご利用中です。前バージョンのシリアル番号は、お客様の<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">アカウント</a>に表示されています。`,
      pvNetworkMaintenanceUserMsg: `お客様はネットワーク ライセンスをご利用中です。前バージョンのシリアル番号は、お客様の<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">アカウント</a>に表示されています。`,
      pvPerpetualUserMsg: 'この製品の永久ライセンスには、前バージョン使用特典が含まれていません。<br/><br/>サブスクリプションには前バージョン使用特典が含まれています。サブスクリプションの特典についての詳細は、<a target="_blank" href="https://www.autodesk.co.jp/subscription">こちら</a>をご覧ください。',
      pvSingleUserSubsMsg: 'お客様はシングルユーザー アクセスのサブスクリプションをご利用中です。3 バージョン前までのバージョンを使用するには、<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">アカウント</a>にログインし、使用する製品を指定してください([シリアル番号を取得]というリンクを使用してください)。',
      serialNumberCurrentLabel: "現在のシリアル番号",
      versionRequestingLabel: "リクエストするバージョン"
    },
    errors: {
      tokenFlexSerialNumber: `TokenFlex のシリアル番号が入力されました。前バージョンのライセンスを申請するには、Autodesk Premier Expert (<strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>) 宛に電子メールをお送りください。`
    },
    requestFailedScreen: {
      pvEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-jpn">資格要件を確認する</a>',
      pvInactiveSubscription: 'お客様の<a target="_blank" href="https://manage.autodesk.com/cep/#products-services">アカウント</a>で本製品のサブスクリプションが現在有効ではないため、このリクエストを完了できません。',
      pvIneligible: "お使いの製品は前バージョン ライセンスの対象製品ではないため、このリクエストを完了できません。"
    }
  },
  cm: {
    welcome: {
      clickGetStarted: "契約管理者を変更するには、[開始]をクリックしてください。",
      modalTitle: "契約管理者を変更",
      noteBullet1: "自動更新に設定されていない保守プランとサブスクリプションの契約管理者を変更できます。",
      noteBullet2: "自動更新に設定されているサブスクリプション契約で契約管理者を変更するには、サブスクリプションを一度キャンセルし、新しいサブスクリプションを契約する必要があります。"
    },
    processInfoScreen: {
      cmEmailPlaceholder: "上記の契約番号に紐付けられている電子メール",
      contractNumDisclaimer: `契約番号にハイフン(-)が含まれる場合はハイフンも含めてください。`,
      contractNumLabel: "契約番号",
      contractNumTooltip: '<a target="_blank" href="https://manage.autodesk.com">Autodesk Account</a> の[請求と注文]タブで契約番号を確認してください。',
      currentCmEmailLabel: "現在の契約管理者の電子メール アドレス",
      newCmEmailLabel: "新しい契約管理者の電子メール アドレス",
      newCmNameLabel: "新しい契約管理者の名前",
      newCmPhoneLabel: "新しい契約管理者の電話番号",
      pageTitle2: "3. 新しい連絡先情報",
      pageTitle: "2. 現在の連絡先情報",
      phoneNumPlaceholder: "市外局番から入力してください"
    },
    authorizationRequestScreen: {
      option1: "私は契約管理者、もしくは、このサブスクリプションを保有する企業からこのリクエストを行う適切な権限が与えられている人物です。",
      confirmLabel: "このリクエストを行う権限があるか確認してください",
      pageTitle: "4. このリクエストの認証"
    },
    successScreen: {
      cmWillReceiveEmail: `新しい契約管理者に追加の手順が記載された電子メールが届きます。`,
      emailWillBeSent: "まもなく確認の電子メールを次の宛先にお送りいたします: <email>",
      responseText4: `契約番号 <contract-number> に新しい契約管理者が設定されました: `
    },
    errors: {
      contractNumNotFound: "契約番号が見つかりません",
      emailNotAssociatedWithcontractNum: "この電子メール アドレスは上記の契約番号に紐付けられていません。",
      enterContractNum: "契約番号を入力してください"
    },
    requestFailedScreen: {
      autoRenewSubs: "オートデスクの記録では、お客様が契約されているのは自動更新のサブスクリプションです。契約管理者を変更するには、サブスクリプションを一度キャンセルし、新しいサブスクリプションを契約する必要があります。",
      autoRenewSubsTitle: "自動更新のサブスクリプション",
      inactiveContract: "お客様の契約は現在有効ではないため、このリクエストを完了できません。",
      inactiveContractTitle: "現在有効ではない契約"
    }
  },
  sc: {
    welcome: {
      clickGetStarted: "ソフトウェア コーディネーターを変更するには、[開始]をクリックしてください。",
      modalTitle: "ソフトウェア コーディネーターを変更",
      noteBullet1: "こちらの方法で、保守プランまたはサブスクリプションのソフトウェア コーディネーターを変更できます(教育機関限定版の製品の場合は変更できません)。"
    },
    processInfoScreen: {
      currentScEmailLabel: "現在のソフトウェア コーディネーターの電子メール アドレス",
      newScEmailLabel: "新しいソフトウェア コーディネーターの電子メール アドレス",
      newScNameLabel: "新しいソフトウェア コーディネーターの名前",
      newScPhoneLabel: "新しいソフトウェア コーディネーターの電話番号",
      scEmailPlaceholder: "上記のシリアル番号に紐付けられている電子メール",
      importantInformation: "重要 情報"
    },
    authorizationRequestScreen: {
      option1: "私は契約管理者、ソフトウェア コーディネーター、もしくは、このサブスクリプションを保有する企業からこのリクエストを行う適切な権限が与えられている人物です。"
    },
    successScreen: {
      responseText4: `シリアル番号 <serial-number> に新しいソフトウェア コーディネーターが設定されました: `,
      scWillReceiveEmail: `新しいソフトウェア コーディネーターに追加の手順が記載された電子メールが届きます。`
    },
    errors: {
      emailNotAssociatedWithSerialNum: "この電子メール アドレスは上記のシリアル番号に紐付けられていません。",
      tokenFlexSerialNumber: `お客様が入力したのは TokenFlex のシリアル番号です。ソフトウェア コーディネータを変更するには、担当のオートデスク プレミア エキスパート <strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong> 宛に電子メールでご連絡ください。.`
    },
    requestFailedScreen: {
      serialNumberIneligle: "お客様のシリアル番号ではソフトウェア コーディネーターの変更ができないため、このリクエストを完了できません。",
      serialNumberIneligleTitle: "対象外のシリアル番号です"
    }
  },
  ccna: {
    welcome: {
      clickGetStarted: `会社の連絡先情報を変更するには、[開始]をクリックしてください。`,
      modalTitle: `会社名または住所を変更する`,
      noteBullet1: `<strong>お客様が契約管理者である場合</strong>、会社名と住所のみを変更できます。`,
      noteBullet2: `<strong>この処理によって所有権が譲渡されることはありません。</strong> 新しい所有者にライセンスを譲渡するには、<a target="_blank" href="https://knowledge.autodesk.com/ja/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses">ライセンス譲渡申請を完了</a>する必要があります。`
    },
    processInfoScreen: {
      reviewInfoTitle: "アカウント情報の確認",
      currentInfoTitle: "現在の情報",
      current: "現在: ",
      pageTitle2: "新しい情報",
      pageTitleValidateAddr: `アドレスを検証`,
      pageTitleConfirmChanges: `変更を確認`,
      changeInfoLabel: `どの情報を変更しますか?`,
      addressOption: `住所`,
      nameOption: `会社名`,
      nameAndAddressOption: `会社名と住所の両方`,
      newTaxIdLabel: `納税用法人番号または EIN をお持ちですか?`,
      msgTOLS: `上記の情報に基づき、新しい所有者にライセンスを譲渡するには、<a target="_blank" href="https://knowledge.autodesk.com/ja/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses">ライセンス譲渡申請を完了</a> する必要があります。詳細なサポートが必要な場合は、<Strong>下記のカスタマー サポートにお問い合わせください</Strong>。`,
      unauthorizedUser: `お客様はこの連絡先に対して変更を行う許可を持っていません。`,
      msgAutoRenew: `自動更新の請求処理に対する会社名または住所の変更、および一部のクラウド ベースのソフトウェア契約は、オンラインでは行えません。<a target="_blank" href="https://knowledge.autodesk.com/ja/customer-service/account-management/account-profile/change-company-name-and-address">会社名または住所を変更</a>するには、次の手順で操作してください。`,
      msgExpiredContract: `この契約は有効期限切れです。`,
      notEligible: `この契約は対象ではありません。`,
      changingInfoFor: `次の契約番号の情報を変更します: <contract-number>`,
      companyName: `会社名`,
      accountCSN: `アカウント CSN`,
      streetAddress: `町名番地 ビル名`,
      city: `市区町村`,
      state: `都道府県`,
      postalCode: `郵便番号`,
      country: `国`,
      validateAddDisclaimer: `最も一致する住所を以下にハイライトします。入力項目を選択すると、処理時間が長くなることがあります。`,
      confirmDisclaimer: `送信する前に、入力内容に間違いがないか確認してください。修正が必要な場合は、直前の画面に戻ります。`,
      recommendedAddr: `最も一致する住所`,
      enteredAddr: `入力された住所`,
      changeWillbeAppliedFor: `変更は次の契約番号に適用されます: <contract-number>`,
      new: `新規`,
      old: `旧`,
      emailWillBeSent: `確認の電子メールの送信先: `
    },
    successScreen: {
      emailWillBeSent: "確認の電子メールを次の宛先にお送りします: <email>",
      changeAppliedFor: `契約番号 <contract-number> は、次のように更新されました: `,
      nonCleansedAddrMsg: `ケース番号が記載された電子メールがまもなく送信されます。 この電子メールを大切に保管しておいてください。.<br><br><strong>お客様のケースに対し、2 営業日以内にご連絡を差し上げます。.</strong><br><br>1 時間以内に確認メールが届かなかった場合は、迷惑メール フォルダを確認するか、ネットワーク管理者にご相談ください。`
    },
    errors: {
      contractNumNotFound: "契約番号が見つかりません",
      invalidContractNum: "契約番号が無効です",
      enterContractNum: "契約番号を入力してください"
    }
  }
};